// extracted by css-extract-rspack-plugin
export default {"fallback":"fallback-l4IRHN","title":"title-LdosVk","body":"body-YkkjpW"};